function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { LOCALE_STATUS_EVENT as t } from "./locale-status-event.js"; /**
                                                                     * @license
                                                                     * Copyright 2021 Google LLC
                                                                     * SPDX-License-Identifier: BSD-3-Clause
                                                                     */
var s = /*#__PURE__*/function () {
  function s(n) {
    var _this = this;
    _classCallCheck(this, s);
    this.__litLocalizeEventHandler = function (o) {
      o.detail.status === "ready" && _this.host.requestUpdate();
    }, this.host = n;
  }
  return _createClass(s, [{
    key: "hostConnected",
    value: function hostConnected() {
      window.addEventListener(t, this.__litLocalizeEventHandler);
    }
  }, {
    key: "hostDisconnected",
    value: function hostDisconnected() {
      window.removeEventListener(t, this.__litLocalizeEventHandler);
    }
  }]);
}();
var a = function a(e) {
    return e.addController(new s(e));
  },
  l = a;
export { l as updateWhenLocaleChanges };